const UNNAMED_FILE_NAME = 'file.pdf', FILE_ARRAY_BUFFER_TYPE = {
    type: 'application/pdf',
}, FILE_ARRAY_OPTIONS = 'arraybuffer';
export { UNNAMED_FILE_NAME, FILE_ARRAY_BUFFER_TYPE, FILE_ARRAY_OPTIONS };
//# sourceMappingURL=files-blob.constants.js.map